<template>
  <div class="comment">
    <div class="comment__avatar">
      <avatar class="user-avatar ms-text" size="default">
        {{ getNameInitials(user) }}
      </avatar>
    </div>
    <div class="comment__info">
      <div class="comment__title">
        <div class="comment__username ms-small-head">
          {{ `${comment.author_last_name} ${comment.author_first_name}` }}
        </div>
        <div class="comment__date ms-help">
          {{ parseTime(comment.created_at) }}
        </div>
      </div>
      <div class="comment__text ms-text">
        <span v-html="comment.text" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mainUrl } from '@/config/urls'
import { getNameInitials } from '@/utils'

export default {
  props: ['comment'],
  data () {
    return {
      mainUrl,
      token: this.$store.state.auth.token
    }
  },
  computed: {
    user () {
      return {
        first_name: this.comment.author_first_name,
        last_name: this.comment.author_last_name
      }
    }
  },
  methods: {
    parseTime (time) {
      return moment(time).format('DD.MM.YYYY HH:mm')
    },
    getNameInitials
  }
}
</script>

<style lang="less">
  .comment {
    display: flex;
    justify-content: flex-start;

    &:not(:first-child) {
      margin-top: 8px;
    }

    &__avatar {
      margin-right: 8px;
    }

    &__title {
      display: flex;
    }

    &__date {
      margin-left: 8px;
    }

    &__text {
      margin-top: 4px;
    }
  }
</style>
